import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { logout, generateId } from "./Utility";
import customFetch from "./apicall/api";
import toast, { Toaster } from 'react-hot-toast';

function PromiseToPay() {
    const history = useHistory();
    const [flag] = useState(0);
    const location = history.location;
    const { smsmobile, Lead_Name, HH_ID, household_id, api_token } = location.state || {};
    const generate_Id1 = generateId(10);

    const [ptpDate, setPtpDate] = useState('');
    const [ptpAmount, setPtpAmount] = useState('');
    const [ptpHistory, setPtpHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notes, setNotes] = useState('');
    const [isListening, setIsListening] = useState(false);
    const [recognition, setRecognition] = useState(null);

    const handle_amount_update = (e) => {
        let value = e.target.value;
        if (value === '') {
            setPtpAmount('');
            return;
        }
        const numericValue = parseFloat(value);
        if (isNaN(numericValue) || numericValue < 0) return;

        value = value.replace(/[^0-9.]/g, '');

        if (/^0[0-9]/.test(value)) {
        value = value.replace(/^0+/, '');
        }

        if (value.startsWith('-')) {
        value = value.replace('-', '');
        }

        const parts = value.split('.');
        if (parts.length > 2) {
        value = parts[0] + '.' + parts[1];
        }

        setPtpAmount(value);
    };


    const handleUpdate = async () => {
        const today = new Date().toISOString().split('T')[0];
        let hasError = false;

        // Check if at least one field is filled
        if (!ptpDate && !ptpAmount && !notes.trim()) {
            toast.error('Please fill at least one field.');
            hasError = true;
        }

        // If date is provided, amount is mandatory
        if (ptpDate && !ptpAmount) {
            toast.error('PTP Amount is required when PTP Date is provided.');
            hasError = true;
        }

        // If amount is provided, date is mandatory
        if (ptpAmount && !ptpDate) {
            toast.error('PTP Date is required when PTP Amount is provided.');
            hasError = true;
        }

        // Validate date only if provided
        if (ptpDate && ptpDate < today) {
            toast.error('Please select a future date.');
            hasError = true;
        }

        // Validate amount only if provided
        if (ptpAmount && parseFloat(ptpAmount) <= 0) {
            toast.error('Please enter a positive amount.');
            hasError = true;
        }

        if (!hasError) {
            setIsSubmitting(true);
            const uid = localStorage.getItem("in_userid");
            const employee_name = localStorage.getItem("employee_name") || localStorage.getItem("in_username") || "";
            const employee_id = localStorage.getItem("employee_id") || localStorage.getItem("in_userid") || "";
            const generate_Id = generateId(10);
            
            const formdata = new FormData();
            formdata.append("household_number", HH_ID);
            formdata.append("employee_name", employee_name);
            formdata.append("employee_id", employee_id);
            if (ptpDate) {
                formdata.append("promise_date", ptpDate);
            }
            if (ptpAmount) {
                formdata.append("promise_amount", ptpAmount);
            }
            if (notes.trim()) {
                formdata.append("remarks", notes);
            }

            try {
                const response = await customFetch(
                    process.env.REACT_APP_URL + "/add/household/ptp",
                    {
                        method: "POST",
                        body: formdata,
                        headers: {
                            "api-token": api_token,
                            component_id: generate_Id1,
                            apiId: generate_Id,
                            api_group_id: "",
                            component: "PromiseToPay",
                            user_id: uid,
                        },
                    }
                );
                const data = await response.json();
                if (response.ok && data.status == 1) {
                    toast.success(data.message || "PTP details added successfully");
                    setPtpDate('');
                    setPtpAmount('');
                    setNotes('');
                    fetchHouseholdData();
                } else {
                    toast.error(data.message || "Failed to add PTP");
                }
            } catch (error) {
                toast.error("Error adding PTP");
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    const fetchHouseholdData = async () => {
        if (!api_token || !HH_ID) return;
        setIsLoading(true);
        const uid = localStorage.getItem("in_userid");
        const generate_Id = generateId(10);
        try {
            const response = await customFetch(
                process.env.REACT_APP_URL + "/fetch/household/ptp?household_no=" + HH_ID,
                {
                    method: "GET",
                    headers: {
                        "api-token": api_token,
                        component_id: generate_Id1,
                        apiId: generate_Id,
                        api_group_id: "",
                        component: "PromiseToPay",
                        user_id: uid,
                    },
                }
            );
            const data = await response.json();
            if (data.ptp_details && data.ptp_details.length > 0) {
                setPtpHistory(data.ptp_details.map(item => {
                    // Handle both flat structure and nested ptp structure
                    const promiseDate = item.promise_date || null;
                    const promiseAmount = item.promise_amount || null;
                    const comment = item.comment || null;
                    const addedAt = item.added_at;
                    const agentName = item.employee_name || 'Unknown';
                    const designation = item.source || 'N/A';
                    
                    return {
                        date: promiseDate && promiseDate !== 'None' ? new Date(promiseDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                        }) : 'N/A',
                        amount: promiseAmount && promiseAmount !== 'None' && !isNaN(parseFloat(promiseAmount)) 
                                    ? parseFloat(promiseAmount)
                                    : 'N/A',
                        comment: comment,
                        source: item.source || 'N/A',
                        added_at: addedAt,
                        created_by: agentName,
                        designation: designation,
                    };
                }));
            }
        } catch (error) {
            toast.error("Error fetching household data");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchHouseholdData();
        
        // Initialize speech recognition
        if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            const recognitionInstance = new SpeechRecognition();
            recognitionInstance.continuous = false;
            recognitionInstance.interimResults = false;
            
            // Support for Indian languages - will auto-detect or can be set to specific language
            recognitionInstance.lang = 'en-IN'; // English (India) - also understands Hinglish
            // Other options: 'hi-IN' (Hindi), 'mr-IN' (Marathi), 'ta-IN' (Tamil), 'te-IN' (Telugu), etc.
            
            recognitionInstance.onresult = (event) => {
                const transcript = event.results[0][0].transcript;
                setNotes(prevNotes => prevNotes + (prevNotes ? ' ' : '') + transcript);
                setIsListening(false);
            };
            
            recognitionInstance.onerror = (event) => {
                toast.error('Speech recognition error: ' + event.error);
                setIsListening(false);
            };
            
            recognitionInstance.onend = () => {
                setIsListening(false);
            };
            
            setRecognition(recognitionInstance);
        }
    }, []);
    
    const startListening = () => {
        if (recognition) {
            setIsListening(true);
            recognition.start();
        } else {
            toast.error('Speech recognition not supported in this browser');
        }
    };
    
    const stopListening = () => {
        if (recognition) {
            recognition.stop();
            setIsListening(false);
        }
    };

    return (
        <>
            <div className="container">
                <div className="top_nav">
                    <a>
                        <div className="icon_bg"  onClick={() => history.goBack()}>
                            <img
                                src={require("../assets/images/back.png")}
                                className="icon_img"
                            />
                        </div>
                    </a>
                    <span className="head-title" style={{ display: 'flex', alignItems: 'center' }}>Visit Notes</span>
                    <a>
                        {flag === 0 && (
                            <div className="log-out-deposit">
                                <img
                                    src={require("../assets/images/power-off.png")}
                                    onClick={() => logout(null, null, true)}
                                    alt=""
                                />
                            </div>
                        )}
                    </a>
                </div>

                <div className="mt-4">
                    {/* Customer Information */}
                    <div className="card mb-4" >
                        {/* <div className="card-header" style={{ backgroundColor: '#60A5FA', color: 'white' }}>
                            <h5 className="mb-0">Customer Information</h5>
                        </div> */}
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <strong>Household Number:</strong> {HH_ID}
                                </div>
                                <div className="col-md-4">
                                    <strong>Phone:</strong> {smsmobile}
                                </div>
                                <div className="col-md-4">
                                    <strong>Name:</strong> {Lead_Name}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* PTP Entry Form */}
                    <div className="card mb-4" >
                        {/* <div className="card-header" style={{ backgroundColor: '#60A5FA', color: 'white' }}>
                            <h5 className="mb-0">PTP Entry</h5>
                        </div> */}
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-5">
                                    <label htmlFor="ptpDate">PTP Date</label>
                                    <div className="input-group">
                                        <input
                                            type="date"
                                            className="form-control"
                                            min={new Date().toISOString().split('T')[0]}
                                            id="ptpDate"
                                            value={ptpDate}
                                            onChange={(e) => setPtpDate(e.target.value)}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text"><i className="fas fa-calendar"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5" style={{ marginTop: window.innerWidth <= 768 ? '1rem' : '0', marginBottom: window.innerWidth <= 768 ? '1rem' : '0' }}>
                                    <label htmlFor="ptpAmount">PTP Amount</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">₹</span>
                                        </div>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="ptpAmount"
                                            value={ptpAmount}
                                            onChange={handle_amount_update}
                                            placeholder="Enter amount"
                                            step="0.01"
                                            min="0"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex align-items-end mb-1">
                                    <button
                                        className="btn btn-primary w-100 "
                                        // style={{ backgroundColor: '#60A5FA', borderColor: '#60A5FA' }}
                                        onClick={handleUpdate}
                                        disabled={isSubmitting}
                                    >
                                        {(isSubmitting) ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                Submitting...
                                            </>
                                        ) : (
                                            'Update'
                                        )}
                                    </button>
                                </div>
                            </div>
                            
                            {/* Notes Section with Speech-to-Text */}
                            <div className="row mt-4">
                                <div className="col-12">
                                    <label htmlFor="notes">
                                        <i className="bi bi-chat-left-text" style={{ marginRight: '8px', color: '#60A5FA' }}></i>
                                        Visit Notes
                                    </label>
                                    <textarea
                                        className="form-control mb-2"
                                        id="notes"
                                        rows="3"
                                        placeholder="Enter visit notes or use voice input"
                                        value={notes}
                                        onChange={(e) => setNotes(e.target.value)}
                                        style={{ resize: 'vertical' }}
                                    ></textarea>
                                    <div className="d-flex gap-2 flex-wrap align-items-center">
                                        <button
                                            className={`btn btn-sm ${isListening ? 'btn-danger' : 'btn-outline-primary'}`}
                                            onClick={isListening ? stopListening : startListening}
                                            type="button"
                                        >
                                            <i className={`bi ${isListening ? 'bi-mic-fill' : 'bi-mic'}`} style={{ marginRight: '5px' }}></i>
                                            {isListening ? 'Stop Recording' : 'Voice Input'}
                                        </button>
                                        {notes && (
                                            <button
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => setNotes('')}
                                                type="button"
                                            >
                                                Clear Notes
                                            </button>
                                        )}
                                        {isListening && (
                                            <small className="text-muted">
                                                <i className="bi bi-soundwave" style={{ marginRight: '5px' }}></i>
                                                Listening...
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Historical PTP Records */}
                    <div className="" >
                    {/* <div className="card-header" style={{ backgroundColor: '#60A5FA', color: 'white', position: 'relative' }}>
                        <h5 className="mb-0">Historical PTP Records</h5>
                    </div> */}
                    <div className="">
                        {isLoading ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                        ) : ptpHistory.length === 0 ? (
                        <p>No PTP records found.</p>
                        ) : (
                        <div className="ptp-list">
                            {ptpHistory.map((entry, index) => (
                            <div
                                key={index}
                                className="ptp-item position-relative"
                                style={{
                                border: '1px solid #f0f0f0',
                                borderRadius: '10px',
                                padding: '16px',
                                marginBottom: '10px',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                backgroundColor: '#fff',
                                }}
                            >
                                {/* Top row: Created datetime and User info */}
                                <div className="d-flex justify-content-between align-items-start flex-wrap mb-3" style={{ gap: '8px' }}>
                                    <div style={{ fontSize: '0.85rem', color: '#666' }}>
                                        <i className="bi bi-clock" style={{ marginRight: '4px', color: '#60A5FA' }}></i> Created At&nbsp;
                                        {entry.added_at ? new Date(entry.added_at).toLocaleString('en-US', {
                                            year: 'numeric',
                                            month: 'short',
                                            day: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        }) : 'N/A'}
                                    </div>
                                    {/* Badge for source - User and designation */}
                                    <span
                                        className="badge"
                                        style={{ border: "1px solid #60A5FA", fontSize: '0.75rem' }}
                                    >
                                        {(!entry.created_by || entry.created_by === 'Unknown' || entry.created_by === '') 
                                            ? entry.designation 
                                            : `${entry.created_by} as ${entry.designation}`}
                                    </span>
                                </div>

                                {/* Bottom row: PTP Date and Amount */}
                                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <i className="bi bi-calendar" style={{ color: '#60A5FA', fontSize: '1.2rem' }}></i>
                                        <div>
                                            <small style={{ color: '#888' }}>PTP Date</small>
                                            <div style={{ fontWeight: '500' }}>{entry.date}</div>
                                        </div>
                                    </div>

                                    {/* Right aligned amount */}
                                    <div className="text-end mt-2 mt-sm-0" style={{ minWidth: '100px' }}>
                                        <small style={{ color: '#888' }}>PTP Amount</small>
                                        <div style={{ fontWeight: '600' }}>
                                            {typeof entry.amount === 'number' ? `₹${entry.amount.toLocaleString()}` : entry.amount}
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Comment Section */}
                                {entry.comment && (
                                    <div style={{ 
                                        backgroundColor: '#f8f9fa', 
                                        padding: '12px', 
                                        borderRadius: '6px',
                                        borderLeft: '3px solid #60A5FA'
                                    }}>
                                        <small style={{ color: '#888', fontWeight: '500' }}>
                                            <i className="bi bi-chat-left-text" style={{ marginRight: '6px' }}></i>
                                            Comment:
                                        </small>
                                        <div style={{ 
                                            marginTop: '6px', 
                                            color: '#333', 
                                            fontSize: '0.9rem',
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word'
                                        }}>
                                            {entry.comment.replace(/_x000D_\r\n/g, '\n').replace(/_x000D_/g, '\n')}
                                        </div>
                                    </div>
                                )}
                            </div>
                            ))}
                        </div>
                        )}
                    </div>
                    </div>
                </div>
            </div>
            <Toaster />
        </>
    );
}

export default PromiseToPay;